// Reactインポート
import React from "react";
import { Link } from "react-router-dom";
// ヘッダースタイル
import "../css/Contact.scss";

// アイコンイメージ
import contactRequestImg from "../img/common/contact.png";
import projectRequestImg from "../img/common/project-request.png";

function Contact() {
	return (
		<div className="contact-section">
			<div className="contact-section-contents">
				<h3 class="tp-sec-tl typo-en" data-num="00/">
					CONTACT
					<span className="wid80">
						ホームページ制作、WEB開発支援、
						<br className="pcOnly" />
						ホームページデザイン・UI/UXデザインに関するお問わせはこちらです
					</span>
				</h3>
				<div className="footer-btn">
					<Link to="/contactform">
						<div className="button1 btn-con">
							<img src={contactRequestImg} alt=""></img>
							<text>無料相談</text>
						</div>
					</Link>

					<Link to="/works">
						<div className="button2 btn-con">
							<img src={projectRequestImg} alt=""></img>
							<text>制作事例</text>
						</div>
					</Link>
				</div>
			</div>
			<h2 className="contact-description">
				千葉県千葉市を拠点とするSmartGenzは、千葉市内をはじめ全国の起業家、事業主、経営者の皆様からのご依頼を幅広く承っております。
				<br />
				ブランディングとリードジェネレーションを融合させたWebサイトを構築し、集客やターゲット顧客への商品・サービスの価値を伝えます。
			</h2>
		</div>
	);
}

export default Contact;
